export const customAttributeCodes = {
  OrderSnapshotId: 'ORDERSNAPSHOTID',
  Fingersize: 'FINGERSIZE',
  Ringsize: 'RINGSIZE',
  MetalColor: 'METALCOLOR',
  YourZodiac: 'YOURZODIAC',
}
